export const formRules = {
  name: [{ required: true, message: "请输入品牌名称" }],
  materialCategoryId: [{ type: "array", required: true, message: "请选择所属分类" }],
};
